import React, { useRef, useState } from "react";
import { Dropdown, Form, Input, message, Modal, Tooltip } from "antd";
import importExportIcon from "../../Assets/import-export.svg";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { importSpaceData } from "../../Reducers/mileSpaceSlice";
import { redrawCanvas } from "../../Utils/canvasUtils";
import { useParams } from "react-router-dom";
import { updateSpace } from "../../Services/spaceServices";

const ImportExportMenu = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const spaceData = useSelector((state) => state.mileSpace.spaceData);
  const documentInfo = useSelector((state) => state.documentData.documentInformation);
  const canvasRef = useSelector((state) => state.mileSpace.canvasRef);
  const fileInputRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileName, setFileName] = useState("");
  const [form] = Form.useForm();

  const handleMenuClick = (key) => {
    if (key === "import") {
      fileInputRef.current.click();
    } else if (key === "export.space") {
      form.setFieldsValue({ fileName: documentInfo?.name || "Untitled document" });
      setFileName(documentInfo?.name || "");
      setIsModalVisible(true);
    }
  };
  
  const handleExport = () => {
    form.validateFields()
      .then(() => {
        try {
          const blob = new Blob([JSON.stringify(spaceData, null, 2)], { type: "application/json" });
          const exportName = fileName.trim();
          saveAs(blob, `${exportName}.space`);
          message.success(`File successfully exported as ${exportName}.space`);
          setIsModalVisible(false);
        } catch (exportError) {
          console.error("Export failed:", exportError);
          message.error("An error occurred during export. Please try again.");
        }
      })
      .catch((validationError) => {
        console.error("Validation failed:", validationError);
        message.error("Please enter a valid file name.");
      });
  };

  const handleImport = async (event) => {
    try {
      const file = event.target.files[0];
      if (file) {
        const text = await file.text();
        const importedData = JSON.parse(text);
        if (importedData) {
          Modal.confirm({
            title: "Confirm",
            content: "Do you want to overwrite?",
            okText: "Yes",
            cancelText: "No",
            onOk: () => {
              dispatch(importSpaceData(importedData));
              redrawCanvas(canvasRef, importedData, dispatch);
              dispatch(updateSpace({ id, updatedData: importedData }));
              message.success("Space imported successfully!");
            },
            onCancel: () => {
              event.target.value = "";
            },
          });
        }
      }
    } catch (error) {
      message.error("Error importing slides. Please check the file format.");
      console.error("Error importing slides:", error);
    } finally {
      event.target.value = "";
    }
  };

  const menuItems = [
    {
      key: "import",
      label: "Import",
    },
    {
      key: "export",
      label: "Export",
      children: [
        {
          key: "export.space",
          label: ".space",
        },
      ],
    },
  ];
  const handleFileNameChange = (e)=>{
    setFileName(e.target.value)
  }
  return (
    <>
      <Tooltip placement="bottom" title="Import/Export">
        <Dropdown
          menu={{
            items: menuItems,
            onClick: ({ key }) => handleMenuClick(key),
          }}
          trigger={["click"]}
          open={isDropdownOpen}
          onOpenChange={setIsDropdownOpen}
        >
          <div>
            <img src={importExportIcon} width={24} alt="Import/Export" />
          </div>
        </Dropdown>
      </Tooltip>
      <input
        type="file"
        accept=".space"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleImport}
      />
      <Modal
        title="Set File Name"
        open={isModalVisible}
        onOk={handleExport}
        onCancel={() => setIsModalVisible(false)}
      >
        <Form form={form}>
          <Form.Item
            label="File Name"
            name="fileName"
            rules={[
              {
                required: true,
                message: "Please enter a file name.",
              },
              {
                pattern: /^[^<>:;,?"*|/\\]+$/,
                message: "File name contains invalid characters.",
              },
            ]}
          >
            <Input
              value={fileName}
              onChange={handleFileNameChange}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ImportExportMenu;
